
const baseUrl = 'https://api.rbsspecialty.com/api/v2';

export default baseUrl;
